/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Exports for test utilities for `id-compressor`
 */

export {
	createAlwaysFinalizedIdCompressor,
	modifyClusterSize,
} from "./idCompressorTestUtilities.js";
